import { timezones } from '@shared/constants';
const parseTimezone = timezoneString => {
  let id = 51;
  let timeZone = timezones?.records?.find(
    timezone => timezone?.name?.toLowerCase() === timezoneString?.toLowerCase()
  );
  if (timeZone) {
    return timeZone.id;
  }
  if (RegExp('eastern', 'gi').test(timezoneString)) {
    id = 51;
  } else if (RegExp('Indianapolis', 'gi').test(timezoneString)) {
    id = 52;
  } else if (RegExp('Central', 'gi').test(timezoneString)) {
    id = 53;
  } else if (RegExp('Phoenix', 'gi').test(timezoneString)) {
    id = 56;
  } else if (RegExp('Mountain', 'gi').test(timezoneString)) {
    id = 57;
  } else if (RegExp('Indianapolis', 'gi').test(timezoneString)) {
    id = 52;
  } else if (RegExp('Pacific', 'gi').test(timezoneString)) {
    id = 58;
  } else if (RegExp('Anchorage', 'gi').test(timezoneString)) {
    id = 59;
  } else if (RegExp('Honolulu', 'gi').test(timezoneString)) {
    id = 60;
  } else if (
    RegExp(/Casablanca|Monrovia|Reykjavik/, 'gi').test(timezoneString)
  ) {
    id = 1;
  } else if (
    RegExp(/Dublin|Edinburgh|Lisbon|London/, 'gi').test(timezoneString)
  ) {
    id = 2;
  } else if (
    RegExp(/Brussels|Copenhagen|Madrid|Paris/, 'gi').test(timezoneString)
  ) {
    id = 3;
  } else if (
    RegExp(/Sarajevo|Skopje|Warsaw|Zagreb/, 'gi').test(timezoneString)
  ) {
    id = 4;
  } else if (
    RegExp(/Belgrade|Bratislava|Budapest|Ljubljana|Prague/, 'gi').test(
      timezoneString
    )
  ) {
    id = 5;
  } else if (
    RegExp(/Amsterdam|Berlin|Bern|Rome|Stockholm|Vienna/, 'gi').test(
      timezoneString
    )
  ) {
    id = 6;
  }

  return id;
};

export default parseTimezone;
